export const DEFAULT_DURATION = 5_000;
export const DEFAULT_ASPECT_RATIO = 16/9;
export const DESKTOP_SECTION_WIDTH = 393;